import { STATIC } from './staticMode';

// Backend base. In the static build there is no backend: audio is bundled and served
// from the same origin, so API_BASE is '' → audio URLs become relative `/audio/...`.
// In local dev, point at the LAN backend (so other devices reach the host machine).
export const API_BASE = STATIC ? '' : `http://${window.location.hostname}:8000`;

export async function api(path, { method = 'GET', token, body } = {}) {
  const headers = {};
  if (body !== undefined) headers['Content-Type'] = 'application/json';
  if (token) headers['X-User-Token'] = token;
  const res = await fetch(API_BASE + path, {
    method, headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let msg = res.statusText;
    try { const j = await res.json(); msg = j.detail || msg; } catch { /* ignore */ }
    throw new Error(msg);
  }
  if (res.status === 204) return null;
  return res.json();
}
